import Vue from "vue";
import QIconPicker from "@quasar/quasar-ui-qiconpicker";
import "@quasar/quasar-ui-qiconpicker/dist/index.css";

Vue.use(QIconPicker);
export default QIconPicker;
